module.exports = __webpack_public_path__ + "static/media/2-c.1d3bdad6.png";